import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
import $ from 'jquery';
/* eslint-disable */
import select2 from "select2";
/* eslint-enable */

Fancybox.bind("[data-fancybox]", {
    keyboard: {
        Escape: "close",
        Delete: "close",
        Tab: 'close',
    },

    Html: {
        video: {
            autoplay: true,
        },
    },
});

$(document).ready(function () {
    $('#blog-category-filter').select2().on('change', searchArticles);
});

const filterItems = document.querySelectorAll('.filter-item');
const filterWrapper = document.querySelectorAll('.filter-wrapper');
const searchField = document.querySelector('.search__input');
const industryFilter = document.querySelector('#blog-category-filter');
const form = document.querySelector('.blog-form');

function searchArticles(e) {
  e.preventDefault();
  const recentPost = document.querySelector('.js-blog-post-recent');
  const searchValue = searchField.value.toLowerCase();
  const industryValue = industryFilter.value;

  if (+industryValue !== 0 || searchValue.length > 0) {
    recentPost.classList.add('hide');
  } else {
    recentPost.classList.remove('hide');
  }

  for(const article of filterItems) {
    const articleTitle = article.querySelector('.blog-posts__text-title');
    let titleText = '';
    if(articleTitle !== null) titleText = articleTitle.textContent.toLowerCase();
    if(titleText.includes(searchValue) && (industryValue === '0' || article.classList.contains(industryValue))) {
      if(article.classList.contains('hide')) article.classList.remove('hide');
    } else {
      article.classList.add('hide');
    }
  }

  filterWrapper.forEach(wrapper => {
    const totalItems = wrapper.querySelectorAll('.filter-item').length;
    const totalHiddenItems = wrapper.querySelectorAll('.filter-item.hide').length;
    const msg = wrapper.querySelector('.warning-msg');

    if (totalItems === totalHiddenItems) {
      msg.classList.remove('hide');
    } else {
      msg.classList.add('hide');
    }
  });
}

form.addEventListener('submit', searchArticles);
searchField.addEventListener('keyup', searchArticles);
